import { useState } from 'react';
import { Alert, Button, TextField } from '@mui/material';
import { authApi } from '../../core/api/client';

type Verification = { email: string; challengeId: string; code: string };
export function OtpFields({ email, purpose, busy, onChange }: {
  email: string; purpose: 'Registration' | 'PasswordReset'; busy: boolean; onChange: (value: Verification) => void;
}) {
  const [challenge, setChallenge] = useState({ email: '', id: '' });
  const [code, setCode] = useState('');
  const [sending, setSending] = useState(false);
  const [retryAt, setRetryAt] = useState(0);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const send = async () => {
    setSending(true); setError(''); setMessage('');
    try {
      const result = await authApi.requestOtp(email, purpose);
      setChallenge({ email, id: result.challengeId }); setCode('');
      onChange({ email, challengeId: result.challengeId, code: '' });
      setRetryAt(Date.now() + 60000);
      setMessage('If eligible, a code has been emailed. It expires in 10 minutes. Wait one minute before resending.');
    } catch (caught) { setError(caught instanceof Error ? caught.message : 'Could not send code.'); }
    finally { setSending(false); }
  };
  return <>
    <Button type="button" disabled={busy || sending || !email.trim()} onClick={() => {
      if (Date.now() < retryAt) { setError('Wait one minute before requesting another code.'); return; }
      void send();
    }}>{sending ? 'Sending�' : challenge.id ? 'Resend verification code' : 'Send verification code'}</Button>
    {message && <Alert severity="info">{message}</Alert>}
    {error && <Alert severity="error">{error}</Alert>}
    <TextField label="Email verification code" value={challenge.email === email ? code : ''} fullWidth required margin="normal"
      disabled={busy || sending || !challenge.id || challenge.email !== email} autoComplete="one-time-code"
      inputProps={{ inputMode: 'numeric', maxLength: 6, pattern: '[0-9]{6}' }}
      onChange={event => { const value = event.target.value.replace(/\D/g, '').slice(0, 6); setCode(value); onChange({ email: challenge.email, challengeId: challenge.id, code: value }); }} />
  </>;
}
